import React from 'react';
import { GetStaticProps } from 'next';
import Image from 'next/image';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useI18n } from 'i18n';
import Head from 'src/components/Head';
import Layout from 'src/components/Layout';
import src1 from 'public/images/design_integration.png';
import src2 from 'public/images/communication.png';
import src3 from 'public/images/education.png';
import src4 from 'public/images/consultation.png';

const Title = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  height: '100%',
  padding: theme.spacing(2),
  [theme.breakpoints.down('lg')]: {
    padding: 0,
  },
}));

export default function UseCases(): React.ReactElement {
  const { t } = useI18n();

  return (
    <>
      <Head title={t('use-cases-title')} description={t('use-cases-description')} />
      <Layout>
        <Typography variant="h4" component="h1" sx={{ p: 4, pl: 0 }}>
          {t('use-cases')}
        </Typography>
        <Paper sx={{ mb: 4, p: 2 }}>
          <Grid container spacing={4} sx={{ pt: 6, pb: 6 }}>
            <Grid item xs={12} md={4}>
              <Title variant="h6">
                {t('design-integration')}
              </Title>
            </Grid>
            <Grid item xs={12} md={8}>
              <Image src={src1} width={970} height={324} alt='design integration' />
            </Grid>
          </Grid>
          <Grid container spacing={4} sx={{ pt: 6, pb: 6 }}>
            <Grid item xs={12} md={4}>
              <Title variant="h6">
                {t('better-communication')}
              </Title>
            </Grid>
            <Grid item xs={12} md={8}>
              <Image src={src2} width={786} height={222} alt='better communication' />
            </Grid>
          </Grid>
          <Grid container spacing={4} sx={{ pt: 6, pb: 6 }}>
            <Grid item xs={12} md={4}>
              <Title variant="h6">
                {t('education-purpose')}
              </Title>
            </Grid>
            <Grid item xs={12} md={8}>
              <Image src={src3} width={829} height={193} alt='education purpose' />
            </Grid>
          </Grid>
          <Grid container spacing={4} sx={{ pt: 6, pb: 6 }}>
            <Grid item xs={12} md={4}>
              <Title variant="h6">
                {t('get-consultation')}
              </Title>
            </Grid>
            <Grid item xs={12} md={8}>
              <Image src={src4} width={800} height={202} alt='get consultation' />
            </Grid>
          </Grid>
        </Paper>
      </Layout>
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
